import { render, staticRenderFns } from "./ScoreDialog.vue?vue&type=template&id=90f6d894&scoped=true&"
import script from "./ScoreDialog.vue?vue&type=script&lang=js&"
export * from "./ScoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDialog.vue?vue&type=style&index=0&id=90f6d894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f6d894",
  null
  
)

export default component.exports